// getIsValidPopupNotification.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getOperationData from '../selector/getOperationData.js';
import {
  POSITION_FULLSCREEN,
  TYPE_LINK,
  DETAIL_SELECT_PATH_PREFIX,
} from '../resource/popupNotificationConstants.js';

/**
 * Get is valid popup notification package.
 * @param {String} {type} - popup notfication embedding data type.
 * @param {String} {position} - popup notfication position.
 * @returns {Boolean} return true if is valid popup notification packag
 */
const getIsValidPackage = ({ type, position }) =>
  !(position === POSITION_FULLSCREEN && type === TYPE_LINK);

/**
 * Select is valid popup notification by notification tag
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {String} notificationTag - notification tag.
 * @return {Boolean} return true if it is valid popoup notification.
 */
const getIsValidPopupNotification = createCachedSelector(
  (state, notificationTag) =>
    getOperationData(state, DETAIL_SELECT_PATH_PREFIX, notificationTag),
  (state, notificationTag) => {
    const notification = getOperationData(
      state,
      DETAIL_SELECT_PATH_PREFIX,
      notificationTag
    );
    const oembed = getOperationData(state, ['oembed'], notification?.link);
    return oembed;
  },
  (notification, oembed) => {
    if (!oembed) {
      return false;
    }

    const isValidPackage = getIsValidPackage({
      type: oembed?.type,
      position: notification?.position,
    });

    return isValidPackage;
  }
)((state, notificationTag) => `${notificationTag}`);

export default getIsValidPopupNotification;
